import { Injectable } from "@angular/core";
import { EdlComment } from "src/app/model/comment.model";
import { DEFAULT_FILTER_DOMAIN } from "../../constants/observation-comments.constants";
import { ObservationTypeValues } from "src/app/model/enum/observation-type-values.enum";

@Injectable({
    providedIn: 'root'
})
export class CommentHelpersService {
    public filterCommentsByDomain(comments: EdlComment[], domainFilterId: string): EdlComment[] {
        if (domainFilterId == DEFAULT_FILTER_DOMAIN) {
            return comments;
        }
        return comments.filter(x => x.lookupValue == domainFilterId);
    }

    public adjustObservationType(observationType: ObservationTypeValues | undefined): ObservationTypeValues | undefined {
        return observationType === ObservationTypeValues.PrincipalSLO ? ObservationTypeValues.SLO : observationType;
    }
}